export default "__VITE_ASSET__JVp6TAV2__"